import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import { IDownloadDocument } from "@/types/IDownloadDocument"
import { IFinanceDataRecord, IFinanceDataRecordCustomer, IFinanceDocument } from "@/types/IFinanceDataRecord"


export const getFinanceDataRecords = (params: IRequestParams): Promise<IPagingResponse<IFinanceDataRecord>> =>
  client.get("/Finance/record", {
    params
  })

export const getFinanceDataRecordFile = (id: number) : Promise<IDownloadDocument> =>
  client.get("/Finance/record/file/" + id)

export const getFinanceDataRecordCustomers = (params: IRequestParams, id: number)
: Promise<IPagingResponse<IFinanceDataRecordCustomer>> =>
  client.get(`/Finance/record/${id}/Customer`, { params })


export const getFinanceDataFromMailboxRecords = (params: IRequestParams): Promise<IPagingResponse<IFinanceDataRecord>> =>
  client.get("/Finance/record-mailbox", {
    params
  })

export const getFinanceDataFromMailboxRecordFile = (id: number) : Promise<IDownloadDocument> =>
  client.get("/Finance/record-mailbox/file/" + id)

export const getFinanceDataFromMailboxRecordCustomers = (params: IRequestParams, id: number)
: Promise<IPagingResponse<IFinanceDataRecordCustomer>> =>
  client.get(`/Finance/record-mailbox/${id}/Customer`, { params })

export const getFinanceDocuments = (params: IRequestParams, customerId: number | null): Promise<IPagingResponse<IFinanceDocument>> =>
  client.get("/Finance/documents", { params: { ...params, customerId } })

export const getFinanceDocument = (id: number) : Promise<IResponse<IDownloadDocument>> =>
  client.get(`/Finance/documents/${id}`)